import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const markPickSessionAsPicked = {
  name: "markPickSessionAsPicked" as const,
  input: z.object({ pickSessionId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
